let viewgird = [
  //
  // ----------
  // 能源管理
  {
    path: '/Dev_Substation',
    name: 'Dev_Substation',
    component: () => import('@/views/device/energy/Dev_Substation.vue')
  },
  {
    path: '/Dev_EnergyStorage',
    name: 'Dev_EnergyStorage',
    component: () => import('@/views/device/energy/Dev_EnergyStorage.vue')
  },
  {
    path: '/Dev_LineGraph',
    name: 'Dev_LineGraph',
    component: () => import('@/views/device/energy/Dev_LineGraph.vue')
  },
  {
    path: '/Dev_LineGraphView',
    name: 'Dev_LineGraphView',
    component: () => import('@/views/device/energy/Dev_LineGraphView.vue')
  },
  {
    path: '/Dev_PowerDiagramX6',
    name: 'Dev_PowerDiagramX6',
    component: () => import('@/views/device/energy/Dev_PowerDiagramX6.vue')
  },
  {
    path: '/Dev_TreeTemplate',
    name: 'Dev_TreeTemplate',
    component: () => import('@/views/device/energy/Dev_TreeTemplate.vue')
  },

  {
    path: '/Dev_HarmonicDetection',
    name: 'Dev_HarmonicDetection',
    component: () => import('@/views/device/energy/Dev_HarmonicDetection.vue')
  },
  {
    path: '/Dev_EnergyFlow',
    name: 'Dev_EnergyFlow',
    component: () => import('@/views/device/energy/Dev_EnergyFlow.vue')
  },
  {
    path: '/Dev_ThreePhaseUnbalanceAngle',
    name: 'Dev_ThreePhaseUnbalanceAngle',
    component: () => import('@/views/device/energy/Dev_ThreePhaseUnbalanceAngle.vue')
  },
  {
    path: '/Dev_ThreePhaseUnbalanceRate',
    name: 'Dev_ThreePhaseUnbalanceRate',
    component: () => import('@/views/device/energy/Dev_ThreePhaseUnbalanceRate.vue')
  },
  {
    path: '/Dev_DeviceEnergy',
    name: 'Dev_DeviceEnergy',
    component: () => import('@/views/device/energy/Dev_DeviceEnergy.vue')
  },
  {
    path: '/Dev_MeterReadingView',
    name: 'Dev_MeterReadingView',
    component: () => import('@/views/device/energy/Dev_MeterReadingView.vue')
  },
  {
    path: '/Dev_DevicePointSet',
    name: 'Dev_DevicePointSet',
    component: () => import('@/views/device/energy/Dev_DevicePointSet.vue')
  },
  {
    path: '/Dev_DevicePointEnergyLog',
    name: 'Dev_DevicePointEnergyLog',
    component: () => import('@/views/device/energy/Dev_DevicePointEnergyLog.vue')
  },
  {
    path: '/Dev_DeviceEnergyChart',
    name: 'Dev_DeviceEnergyChart',
    component: () => import('@/views/device/energy/Dev_DeviceEnergyChart.vue')
  },
  {
    path: '/Dev_DevicePointEnergyChart',
    name: 'Dev_DevicePointEnergyChart',
    component: () => import('@/views/device/energy/Dev_DevicePointEnergyChart.vue')
  },
  {
    path: '/Dev_Environment',
    name: 'Dev_Environment',
    component: () => import('@/views/device/energy/Dev_Environment.vue')
  },
  {
    path: '/Dev_EnergyReport',
    name: 'Dev_EnergyReport',
    component: () => import('@/views/device/energy/Dev_EnergyReport.vue')
  },
  {
    path: '/Dev_DrawIO',
    name: 'Dev_DrawIO',
    component: () => import('@/views/device/energy/Dev_DrawIO.vue'),
    meta: {
      // 页面不缓存，每次刷新都重新加载
      // true 缓存，每次刷新都从缓存中获取
      keepAlive: false
    }
  },
  {
    path: '/Dev_DeviceLoad',
    name: 'Dev_DeviceLoad',
    component: () => import('@/views/device/energy/Dev_DeviceLoad.vue')
  },
  {
    path: '/Dev_DeviceLoadChart',
    name: 'Dev_DeviceLoadChart',
    component: () => import('@/views/device/energy/Dev_DeviceLoadChart.vue')
  },
  {
    path: '/Dev_DeviceFhChart',
    name: 'Dev_DeviceFhChart',
    component: () => import('@/views/device/energy/Dev_DeviceFhChart.vue')
  },
  {
    path: '/Dev_DeviceRealTimeChart',
    name: 'Dev_DeviceRealTimeChart',
    component: () => import('@/views/device/energy/Dev_DeviceRealTimeChart.vue')
  },
  {
    path: '/Dev_DevicePointEnergyLogDataProcessing',
    name: 'Dev_DevicePointEnergyLogDataProcessing',
    component: () => import('@/views/device/energy/Dev_DevicePointEnergyLogDataProcessing.vue')
  },
  {
    path: '/Dev_DeviceMultiComparison',
    name: 'Dev_DeviceMultiComparison',
    component: () => import('@/views/device/energy/Dev_DeviceMultiComparison.vue')
  },
  // {
  //   path: '/Dashboard_Substation',
  //   name: 'Dashboard_Substation',
  //   component: () => import('@/views/device/energy/Dashboard/Dashboard_Substation.vue')
  // },
  // {
  //   path: '/Dashboard_StationScreen',
  //   name: 'Dashboard_StationScreen',
  //   component: () => import('@/views/device/energy/Dashboard/Dashboard_StationScreen.vue')
  // },
  {
    path: '/Dev_EnergyProperty',
    name: 'Dev_EnergyProperty',
    component: () => import('@/views/device/energy/Dev_EnergyProperty.vue')
  },
  {
    path: '/UnitMonitor',
    name: 'UnitMonitor',
    component: () => import('@/views/device/energy/Dashboard/UnitMonitor.vue')
  },
  {
    path: '/Ene_EnergyTcp',
    name: 'Ene_EnergyTcp',
    component: () => import('@/views/device/energy/Ene_EnergyTcp.vue')
  },
  {
    path: '/Ene_EnergyTcpLog',
    name: 'Ene_EnergyTcpLog',
    component: () => import('@/views/device/energy/Ene_EnergyTcpLog.vue')
  },
  {
    path: '/Dev_SubstationDevice',
    name: 'Dev_SubstationDevice',
    component: () => import('@/views/device/energy/Dev_SubstationDevice.vue')
  },
  {
    path: '/Dev_EnergyStorageDevice',
    name: 'Dev_EnergyStorageDevice',
    component: () => import('@/views/device/energy/Dev_EnergyStorageDevice.vue')
  },
  {
    path: '/Ene_ACControl',
    name: 'Ene_ACControl',
    component: () => import('@/views/device/energy/Ene_ACControl.vue')
  },
  {
    path: '/Ene_BoilerControl',
    name: 'Ene_BoilerControl',
    component: () => import('@/views/device/energy/Ene_BoilerControl.vue')
  },
  {
    path: '/Ene_BoilerMaintain',
    name: 'Ene_BoilerMaintain',
    component: () => import('@/views/device/energy/Ene_BoilerMaintain.vue')
  },
  {
    path: '/Ene_BoilerControlView',
    name: 'Ene_BoilerControlView',
    component: () => import('@/views/device/energy/Ene_BoilerControlView.vue')
  },
  
  {
    path: '/Ene_BoilerControlConfig',
    name: 'Ene_BoilerControlConfig',
    component: () => import('@/views/device/energy/Ene_BoilerControlConfig.vue')
  },
  {
    path: '/Ene_HolidayMaintain',
    name: 'Ene_HolidayMaintain',
    component: () => import('@/views/device/energy/Ene_HolidayMaintain.vue')
  },
  {
    path: '/Ene_DeviceControllerLog',
    name: 'Ene_DeviceControllerLog',
    component: () => import('@/views/device/energy/Ene_DeviceControllerLog.vue')
  },
  {
    path: '/Ene_ACMaintain',
    name: 'Ene_ACMaintain',
    component: () => import('@/views/device/energy/Ene_ACMaintain.vue')
  },
  {
    path: '/Ene_ACGlobalConfig',
    name: 'Ene_ACGlobalConfig',
    component: () => import('@/views/device/energy/Ene_ACGlobalConfig.vue')
  },
  // {
  //   path: '/Dev_Energy',
  //   name: 'Dev_Energy',
  //   component: () => import('@/views/device/energy/Dev_Energy.vue')
  // },
  // 能源管理
  // ----------
  // ? 总览
  // ? 电能监控
  // ? 变压器监控
  // ? 运营效率监控
  {
    path: '/overview',
    name: 'overview',
    component: () => import('@/views/Ene/PowerStationMonitoring/overview.vue')
  },
  {
    path: '/electricalMonitoring',
    name: 'electricalMonitoring',
    component: () => import('@/views/Ene/PowerStationMonitoring/electricalMonitoring.vue')
  },
  {
    path: '/transformerMonitoring',
    name: 'transformerMonitoring',
    component: () => import('@/views/Ene/PowerStationMonitoring/transformerMonitoring.vue')
  },
  {
    path: '/operationalEnergyEfficiency',
    name: 'operationalEnergyEfficiency',
    component: () => import('@/views/Ene/PowerStationMonitoring/operationalEnergyEfficiency.vue')
  },
];

export default viewgird;
